/* eslint-disable react/display-name */
import React from "react";
import { Box } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Multiselect from "multiselect-react-dropdown";

const SELECT_ALL_KEY = "__MS2_SELECT_ALL__";

const useStyles = makeStyles((theme: Theme) => createStyles({}));
const MenuProps = {
  PaperProps: {},
  getContentAnchorEl: null,
};

const isSelectAllItem = (item: any) => item?.__ms2SelectAll === true;

interface Props {
  renderGroup?: any;
  allValues: any;
  onSelect: any;
  onRemove?: any;
  selctedItems?: any;
  errorText?: any;
  displayValue?: any;
  placeholder?: any;
  ref?: any;
  showSelectAll?: boolean;
  selectAllLabel?: string;
  closeOnSelect?: boolean;
}
const MultiSelect2 = React.forwardRef(
  (
    {
      renderGroup,
      allValues,
      onSelect,
      onRemove,
      selctedItems,
      errorText,
      displayValue,
      placeholder,
      showSelectAll = false,
      selectAllLabel = "Select All",
      closeOnSelect = true,
    }: Props,
    ref: any
  ) => {
    const classes = useStyles();
    const multiselectRef: any = React.createRef();
    const resetValues = () => {
      multiselectRef?.current.resetSelectedValues();
    };
    React.useImperativeHandle(ref, () => ({
      getUpdated() {
        resetValues();
      },
    }));

    const options = React.useMemo(() => {
      const values = Array.isArray(allValues) ? allValues : [];
      if (!showSelectAll || !values.length) return values;

      const labelKey = displayValue || "name";
      return [{ [labelKey]: selectAllLabel, __ms2SelectAll: true, id: SELECT_ALL_KEY }, ...values];
    }, [allValues, displayValue, selectAllLabel, showSelectAll]);

    const handleSelect = (selectedList: any[], selectedItem: any) => {
      if (isSelectAllItem(selectedItem)) {
        const values = Array.isArray(allValues) ? allValues : [];
        const allSelected = values.length > 0 && selctedItems?.length === values.length;
        if (allSelected) {
          onRemove?.([], selectedItem);
        } else {
          onSelect(values, selectedItem);
        }
        return;
      }

      const filtered = (selectedList || []).filter((item) => !isSelectAllItem(item));
      onSelect(filtered, selectedItem);
    };

    const handleRemove = (selectedList: any[], removedItem: any) => {
      if (isSelectAllItem(removedItem)) {
        onRemove?.([], removedItem);
        return;
      }

      const filtered = (selectedList || []).filter((item) => !isSelectAllItem(item));
      onRemove?.(filtered, removedItem);
    };

    return (
      <div>
        <Box>
          <Multiselect
            groupBy={renderGroup}
            showCheckbox={true}
            closeOnSelect={closeOnSelect}
            options={options}
            selectedValues={selctedItems}
            displayValue={displayValue}
            onSelect={handleSelect}
            onRemove={handleRemove}
            placeholder={placeholder}
            ref={multiselectRef}
          />
          <span style={{ color: "red" }}>{errorText} </span>
        </Box>
      </div>
    );
  }
);
export default MultiSelect2;
